import axios from 'axios';
import { env } from '../env';

import { IAssistantScript } from '@interfaces/assistantScript';

const { REACT_APP_API_URL } = env;

/**
 * Provides functionality to retrieve assistant scripts.
 *
 * @layer service
 * @feature assistant-scripts
 * @uses axios
 *
 * @description
 * This service class is responsible for fetching assistant scripts from the API.
 * It encapsulates the logic for making HTTP requests to the backend and processing
 * the response data.
 */
export default class AssistantScriptsService {
  /**
   * Retrieves assistant scripts based on the provided configuration.
   *
   * This method fetches scripts that assist in various tasks, utilizing the given configuration
   * to determine which scripts to retrieve and how to process them.
   *
   * @param config - An object containing configuration settings for fetching the scripts.
   *                 Defaults to an empty object if not provided.
   * @returns A promise that resolves to an array of assistant scripts.
   *
   * @uses Potentially calls external services or databases to fetch the scripts.
   */
  static async getAssistantScripts(
    config: any = {},
  ): Promise<IAssistantScript[]> {
    const { data } = await axios.get(
      `${REACT_APP_API_URL}api/v2/assistant/scripts`,
      {
        ...config,
      },
    );

    return data;
  }
}
